import { EOnboardingStep } from 'enums/user.enum';

export const resolveOnboardingStatus = (
  status: EOnboardingStep | null,
  isError: boolean,
  canCreateBuildings: boolean,
) => {
  const resolvedStatus = status || (isError ? EOnboardingStep.COMPLETED : EOnboardingStep.SETUP_BUILDING);

  return !canCreateBuildings && resolvedStatus === EOnboardingStep.SETUP_BUILDING
    ? EOnboardingStep.SETUP_ZONE
    : resolvedStatus;
};
